import { Fields } from 'common/form';
import { EditEngagementCampaignDetails } from '../schemas/editEngagementCampaignDetailsSchema';

export const editEngagementCampaignDetailsFields: Fields<EditEngagementCampaignDetails> =
  {
    title: {
      label: 'Campaign title',
      type: 'text'
    },
    outreachDescription: {
      label: 'Campaign description',
      type: 'textarea',
      rows: 17
    }
  };
